module.exports = __webpack_public_path__ + "files/aa6046ead6b3601362aa0ca0181c90ec.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Arvo-regular.woff
// module id = 755
// module chunks = 60